export default __webpack_public_path__ + "static/media/mockup-magazines.c06ee209.png";